import { ReactNode } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import AccountCreation, { Input } from "@/components/signup/account-creation";
import { CobrandedProductLogo } from "@/components/signup/bxp-ui-signup/src/components/site-name-form/components/variants/new-user-confluence-workspace-name";
import { SignupBackgroundLayout } from "@/components/signup/layouts";
import { wacToken } from "@/libraries/design/foundations";
import { withFeatureExposed } from "@/utils/feature-exposed";

import { Jfind1315SubHeading } from "../components/jfind-1315-subheading";

export const LoggedOutConfluenceFormComponent = () => {
    return (
        <SignupBackgroundLayout
            ProductLogo={<CobrandedProductLogo />}
            page="SIGNUP_FORM"
        >
            <h1 css={h1Css}>
                <FormattedMessage
                    id="BxpUiSignup.SignupForm.cfind2049.header"
                    defaultMessage="Get <underline-word>started</underline-word> with Confluence"
                    values={{
                        "underline-word": UnderlineWord
                    }}
                />
            </h1>
            <Jfind1315SubHeading />
            <AccountCreation Input={<Input helpText={null} />} />
        </SignupBackgroundLayout>
    );
};

export const UnderlineWord = (node: ReactNode) => (
    <span css={scribbleSpanCss}>
        {node}
        <svg aria-hidden={true} css={accentImageCss} viewBox="0 0 105 17">
            <path d="M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z" />
        </svg>
    </span>
);

export const CobrandedLoggedOutForm = withFeatureExposed(
    "cfind-2409-v2-cobranding-signup",
    "test",
    LoggedOutConfluenceFormComponent
);

const h1Css = css({
    color: wacToken("color.primary.black"),
    fontFamily: wacToken("font.charlie.display"),
    fontSize: "32px",
    fontWeight: 700,
    margin: 0,
    textAlign: "center"
});

const scribbleSpanCss = css({
    position: "relative"
});

const accentImageCss = css({
    fill: wacToken("color.primary.yellow"),
    height: "15px",
    insetBlockEnd: "-8px",
    insetInlineStart: 0,
    position: "absolute",
    transform: "rotate(-0.77deg)",
    width: "104px"
});
